module.exports = {"150625100":"锡尼镇","150625101":"巴拉贡镇","150625102":"吉日嘎朗图镇","150625103":"独贵特拉镇","150625104":"呼和木独镇","150625200":"伊和乌素苏木乡","150625400":"杭锦旗独贵塔拉工业园区管理委员会","150625401":"鄂尔多斯新能源产业示范区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150625.json
// module id = 442
// module chunks = 0